import { createViewModelContext } from '@caudena/core/utils/mobxUtils'
import { IIncidentActionsController } from './IncidentActionsController'

export const {
  ViewModelProvider: IncidentActionsProvider,
  useViewModel: useIncidentActions,
} = createViewModelContext<IIncidentActionsController>()
